export const CREATE_PROJECTGOALS_REQUEST = 'CREATE_PROJECTGOALS_REQUEST';
export const CREATE_PROJECTGOALS_SUCCESS = 'CREATE_PROJECTGOALS_SUCCESS';
export const CREATE_PROJECTGOALS_FAILURE = 'CREATE_PROJECTGOALS_FAILURE';